import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid2, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import SubjectStatusCaps from "./SubjectStatusCaps/SubjectStatusCaps";
import StratsCap from "./StratsCap/StratsCap";
import CountryCaps from "./CountryCap/CountryCap";
import { getStudySiteCapDataService } from "../../services/siteManagamentService";
import { Home } from "@mui/icons-material";

export const capLevelTypeIds = {
  cohort: "D5E68790-EA65-4E16-9CC1-0639D0529C30",
  study: "AA78B349-AD29-4189-B8F8-3B9BA08007A9",
  strata: "200A53F7-1ED1-45E8-9DBC-6DA3133A263F",
  site: "09F7B307-B506-491C-BB6B-78D973CEFFD3",
  country: "190F36A6-60A8-4660-AD88-C4651F30B73E",
};

const StudyCaps = () => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("study");
  const [load, setLoad] = useState(false);
  const [loadData, setLoadData] = useState({
    statusData: [],
    countryData: [],
    strataData: [],
  });
  const [rowData, setRowData] = useState([]);
  const access_token = localStorage?.getItem("access_token");

  const userId = localStorage.getItem("roleId");
  const globalDateFormat = localStorage.getItem("globalDateFormat");

  const { countryData, statusData, strataData } = loadData;

  useEffect(() => {
    if (access_token && tabValue) {
      getLoadData(tabValue);
    }
  }, [tabValue]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getLoadData = async (tabValue) => {
    try {
      setLoad(true);
      const res = await getStudySiteCapDataService(
        access_token,
        null,
        capLevelTypeIds[tabValue],
      );
      if (res?.data?.message === "Onload Data Extracted!") {
        setLoadData({
          countryData: res?.data?.result?.countries,
          strataData: res?.data?.result?.strata,
          statusData: res?.data?.result?.patientStatusTypes,
        });
        setRowData(res?.data?.result?.caps);
      }
    } catch (err) {
      console.log(err);
      if (err.status == 401) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <div className="content-body">
      <div className="home-container">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/subject">
            Study Caps
          </Link>
          -{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
        <Link className="bread-crumbs-link home-inner-container">
          Set as Home Page
          <span>
            <Home
              sx={{
                fontSize: "20px",
              }}
            />
          </span>
        </Link>
      </div>

      {/* Tab Content */}

      <Box sx={{ width: "100%", mt: 2 }}>
        <TabContext value={tabValue}>
          <Box sx={{ position: "relative", zIndex: 2 }}>
            <TabList
              onChange={handleTabChange}
              aria-label="lab API tabs example"
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                minHeight: "48px",

                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 500,
                  px: 3,
                  minHeight: "48px",
                  border: "1px solid transparent",
                  borderBottom: "none",
                  borderRadius: "8px 8px 0 0",
                  backgroundColor: "transparent",
                  color: "text.secondary",
                  position: "relative",
                  zIndex: 1,
                },

                "& .Mui-selected": {
                  backgroundColor: "#FFFFFF",
                  color: "primary.main",
                  fontWeight: 600,
                  border: "1px solid #d0d7e2",
                  borderBottom: "none",
                  zIndex: 3,
                },
              }}
            >
              <Tab label="Subject Status Caps" value="study" />
              <Tab label="Strata Caps" value="strata" />
              <Tab label="Country Caps" value="country" />
            </TabList>
          </Box>
          <Box
            sx={{
              border: "1px solid #d0d7e2",
              borderRadius: "0 8px 8px 8px",
              backgroundColor: "#ffffff",
              p: 3,
              marginTop: "-1px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              position: "relative",
              zIndex: 1,
            }}
          >
            {load ? (
              <Loader />
            ) : (
              <>
                <TabPanel value="study" sx={{ padding: "30px 0px" }}>
                  <SubjectStatusCaps
                    access_token={access_token}
                    statusData={statusData}
                    userId={userId}
                    globalDateFormat={globalDateFormat}
                    setLoad={setLoad}
                    rowData={rowData}
                    onLoadData={getLoadData}
                  />
                </TabPanel>
                <TabPanel value="strata" sx={{ padding: "30px 0px" }}>
                  <StratsCap
                    rowData={rowData}
                    strataData={strataData}
                    statusData={statusData}
                    onLoadData={getLoadData}
                    setLoad={setLoad}
                    globalDateFormat={globalDateFormat}
                    access_token={access_token}
                    userId={userId}
                  />
                </TabPanel>
                <TabPanel value="country" sx={{ padding: "30px 0px" }}>
                  <CountryCaps
                    countryData={countryData}
                    statusData={statusData}
                    access_token={access_token}
                    globalDateFormat={globalDateFormat}
                    onLoadData={getLoadData}
                    rowData={rowData}
                    setLoad={setLoad}
                    userId={userId}
                  />
                </TabPanel>
              </>
            )}
          </Box>
        </TabContext>
      </Box>

      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button className="create-btn">Back</button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default StudyCaps;
